import React, { useEffect, useRef, useState } from 'react';
import { SprayCampaign } from '../../../types/spray';
import { 
  Droplet, 
  Box,
  FileText, 
  AlertCircle, 
  Calendar,
  Tag
} from 'react-feather';


import { sprayTypes } from '../../../types/spray';
import { useProducts, usePests, useCultureStages } from '../../../helpers/hooks';
interface SprayHeaderCardProps {
  spray: SprayCampaign;
}

export const SprayHeaderCard: React.FC<SprayHeaderCardProps> = ({ spray }) => {

  const [showDetails, setShowDetails] = useState(false);

  const { toProductName } = useProducts();
  const { toPestName } = usePests();
  const { toCultureStage } = useCultureStages();

  const mainProductName = toProductName(spray.mainProductID);
  const pestName = spray.pestID ? toPestName(spray.pestID) : null;
  const startStage = spray.cultureStageStartID ? toCultureStage(spray.cultureStageStartID) : null;
  const endStage = spray.cultureStageEndID ? toCultureStage(spray.cultureStageEndID) : null;
  const sprayType = sprayTypes.find(type => type.value === spray.type);
  const detailsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (detailsRef.current && !detailsRef.current.contains(event.target as Node)) {
        setShowDetails(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const InfoRow = ({ icon: Icon, label, value }: { icon?: any, label?: string | null, value?: string | number | null }) => {
 
    if (value) return (
      <>
      <div className="d-flex align-items-center mb-2">
        <div className="d-flex align-items-center" style={{ fontWeight: 'bold', color: 'blue' }}>
          <Icon size={18} className="me-2" />
          <span className="fw-bold me-2">{label}:</span>
        </div>

        </div>
        <div className="d-flex align-items-center mb-2">
          <div className="d-flex align-items-center" style={{ marginLeft : '40px' }}>
            <span>{value}</span>
          </div>

      </div>
      </>
    );
    return null;
  };

  const MainView = () => (
    <div 
      className="card p-3 mb-3 cursor-pointer" 
      onClick={() => setShowDetails(true)}
      style={{ cursor: 'pointer' }}
    >
      <h3 style={{ fontWeight: 'bold', color: 'blue', textAlign: 'center' }}>
        Traitement programmé
      </h3>

      <InfoRow 
        icon={Tag} 
        label="Produit principal" 
        value={mainProductName}
      />      
      <InfoRow 
        icon={FileText} 
        label="Description" 
        value={spray.description}
      /> 
      <InfoRow 
        icon={Droplet} 
        label="Citernes" 
        value={`${spray.plannedTotalVolumeL/spray.plannedSprayTankVolumeL 
                 + ' x ' + spray.plannedSprayTankVolumeL} L`}
      />

      <div className="d-flex justify-content-end">
        <span style={{ fontSize: '12px', color: 'blue !important' }}>plus...</span>
      </div>
    </div>
  );

  const DetailsView = () => (
    <div 
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ 
        backgroundColor: 'rgba(0,0,0,0.5)', 
        zIndex: 1000,
      }}
      onClick={(e) => {
        setShowDetails(false);
      }}
    >
      <div 
        ref={detailsRef}
        className="card p-4" 
        style={{ 
          maxWidth: '600px',
          maxHeight: '90vh',
          overflow: 'auto',
          backgroundColor: 'white',
        }}
        onClick={(e) => {
          setShowDetails(false);
        }}
      >
        <InfoRow 
          icon={Tag} 
          label="Type" 
          value={sprayType?.label}
        />
        <InfoRow 
          icon={Box} 
          label="Produit principal" 
          value={mainProductName}
        />
        <InfoRow 
          icon={Droplet} 
          label="Citernes" 
          value={`${spray.plannedTotalVolumeL/spray.plannedSprayTankVolumeL 
                  + ' x ' + spray.plannedSprayTankVolumeL} L`}
        />
        <InfoRow 
          icon={AlertCircle} 
          label="Raison" 
          value={pestName}
        />
        <InfoRow 
          icon={FileText} 
          label="Remarques" 
          value={spray.sprayNotes}
        />
        <InfoRow 
          icon={Calendar} 
          label="Stade de départ" 
          value={startStage ? `BBCH ${startStage.bbch} - ${startStage.description}` : null}
        />
        <InfoRow 
          icon={Calendar} 
          label="Stade final" 
          value={endStage ? `BBCH ${endStage.bbch} - ${endStage.description}` : null}
        />
      </div>
    </div>
  );

  return (
    <>
      {showDetails ? <DetailsView /> : <MainView />}
    </>
  );
};